import { DownloadIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl, FormHelperText,
  Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  useDisclosure
} from "@chakra-ui/react";
import React, {useState} from "react";

type DownloadFilesProps = {
  onFileSent: (file: File) => void;
  buttonName: string;
  modalName: string;
  modalButton: string;
};

const DownloadFilesFromList = (props: DownloadFilesProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [file, setFile] = useState<File | null>(null);

  function handleChange(e: any) {
    setFile(e.target.files[0]);
  }

  function handleDownloadClick() {
    if (file) {
      props.onFileSent(file);
    }
    onClose();
  }

  return (
    <>
      <Button leftIcon={<DownloadIcon />} colorScheme="teal" onClick={onOpen}>
        {props.buttonName}
      </Button>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.modalName}</ModalHeader>
          <ModalBody>
            <FormControl id="file-form-control" paddingBottom="6">
              <input name="file-input" type="file" onChange={handleChange} />
              <FormHelperText>
                Seleccione un archivo en formato xlsx.
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalCloseButton />
          <ModalFooter>
            <Button
              colorScheme="teal"
              type="submit"
              isDisabled={!file}
              onClick={handleDownloadClick}
            >
              {props.modalButton}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DownloadFilesFromList;
